<template>
  <v-row>
    <v-col cols="12">
      <v-card tile flat outlined color="transparent" class="mb-5">
        <v-card-text>
          <div class="body-1" v-if="customer.description">
            <strong>Description: </strong>
            <div>{{ customer.description }}</div>
          </div>

          <div class="body-1" v-if="customer.email">
            <strong>Email: </strong>
            <a :href="'mailto:' + customer.email">{{ customer.email }}</a>
          </div>

          <div class="body-1" v-if="customer.phone">
            <strong>Phone: </strong>
            <a :href="'tel:' + customer.phone">{{ customer.phone }}</a>
          </div>

          <div class="body-1" v-if="customer.wiki">
            <strong>Wiki: </strong>
            <a :href="customer.wiki" target="_blank">{{ customer.wiki }}</a>
          </div>
        </v-card-text>
      </v-card>

      <v-card tile flat color="transparent">
        <v-card-title class="px-0 pt-0">Projects</v-card-title>

        <v-card-text class="pa-0">
          <v-row v-if="customer.projects && customer.projects.length">
            <v-col
              cols="4"
              v-for="project in customer.projects"
              :key="project.id"
            >
              <v-card
                width="100%"
                height="100%"
                outlined
                :to="{ name: 'project', params: { project_id: project.id } }"
              >
                <v-card-title>{{ project.name }}</v-card-title>
                <v-card-text>{{ project.description }}</v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row v-else>
            <v-col cols="12">
              <v-card width="100%" outlined>
                <v-card-text>
                  <div class="title">No projects found.</div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CustomerOverview',
  components: {},
  computed: {
    ...mapGetters('customers', ['customer'])
  }
}
</script>
